module.exports = __webpack_public_path__ + "img/orders.3c3a814d.svg";